<template>
  <div class="toWxjcgl">
    <!-- toWxjcgl -->
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'toWxjcgl',
  computed: {
    ...mapState(['token', 'userInfo']),
  },
  created() {
    let timeStamp = new Date().getTime();
    if (process.env.NODE_ENV === 'development') {
      window.open(
        'https://fc.mypy.cn/szzhwy/dztp/pc/login_new.do?token=' +
          this.token +
          '&t=' +
          timeStamp
      );
    } else if (process.env.NODE_ENV === 'production') {
      window.open(
        'https://zjj.sz.gov.cn/wxjwx/pc/login_new.do?token=' +
          this.token +
          '&code=' +
          localStorage.getItem('code') +
          '&t=' +
          timeStamp
      );
    }

    this.$router.go(-1);
  },
};
</script>

<style></style>
